import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '@deque/cauldron-react';

interface Props {
  screenshot: Blob | null;
  screenshotRef?: React.Ref<HTMLImageElement>;
  screenshotStyles?: React.CSSProperties;
  loading?: boolean;
  error?: Error | null;
}

const Screenshot: React.FC<Props> = ({
  screenshot,
  screenshotRef,
  screenshotStyles,
  loading,
  error
}) => {
  const { t } = useTranslation();

  if (loading) {
    return <Loader label={t('Loading screenshot')} />;
  }

  if (error || !screenshot) {
    return <p>{t('Could not load the screenshot')}</p>;
  }

  return (
    <img
      src={URL.createObjectURL(screenshot)}
      alt={t('screenshot of the issue')}
      ref={screenshotRef}
      style={screenshotStyles}
    />
  );
};

export default Screenshot;
